"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAttributeMetadataObject = void 0;
// (C) 2019-2021 GoodData Corporation
var types_1 = require("../types");
/**
 * Tests whether the provided object is of type {@link IAttributeMetadataObject}.
 *
 * @param obj - object to test
 * @public
 */
function isAttributeMetadataObject(obj) {
    return types_1.isMetadataObject(obj) && obj.type === "attribute";
}
exports.isAttributeMetadataObject = isAttributeMetadataObject;
//# sourceMappingURL=index.js.map